"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldDisableOrderPickupDate = function (date) {
    if (!date) {
        return true;
    }
    var dayNumber = date.isoWeekday();
    return dayNumber === 6 || dayNumber === 7;
};
//# sourceMappingURL=shouldDisableOrderPickupDate.js.map